import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AddToBlackListRequest, BlackListEntity } from "./types";

import { Data } from "@/shared/types.ts";
import api from "@/shared/api";

const BLACK_LIST_KEY = "sms_black_list";

export function useBlackList() {
  return useQuery<Data<BlackListEntity[]>>({
    queryKey: [BLACK_LIST_KEY],
    queryFn: (ctx) =>
      api
        .get<
          Data<BlackListEntity[]>
        >("/api/v1/admin/sms/black-list", { signal: ctx.signal })
        .json(),
    initialData: { data: [], code: 0, description: "", success: true },
  });
}

export function useAddToBlackList() {
  const queryClient = useQueryClient();

  return useMutation<Data<BlackListEntity>, Error, AddToBlackListRequest>({
    mutationFn: (data) =>
      api.post("/api/v1/admin/sms/black-list", { json: data }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BLACK_LIST_KEY] });
    },
  });
}

export function useRemoveFromBlackList() {
  const queryClient = useQueryClient();

  return useMutation<Data<boolean>, Error, { id: number }>({
    mutationFn: ({ id }) =>
      api.delete(`/api/v1/admin/sms/black-list/${id}`).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BLACK_LIST_KEY] });
    },
  });
}
